import React from 'react';
import { TrendingUp, Users, Mail, Clock } from 'lucide-react';
import { useEmailStats } from '../../../hooks/useEmailAdmin';

export default function EmailStats() {
  const { stats, loading, error } = useEmailStats();

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="animate-pulse bg-gray-200 dark:bg-gray-700 rounded-lg h-32"></div>
        ))}
      </div>
    );
  }

  if (error || !stats) {
    return null;
  }

  const cards = [
    {
      title: 'Total Subscribers',
      value: stats.subscribers?.total ?? 0,
      subtitle: `${stats.subscribers?.active ?? 0} active, ${stats.subscribers?.verified ?? 0} verified`,
      icon: Users,
      accentClass: 'bg-blue-100 text-blue-600',
    },
    {
      title: 'Emails Sent Today',
      value: stats.emailsSent?.today ?? 0,
      subtitle: `${stats.emailsSent?.thisWeek ?? 0} this week`,
      icon: Mail,
      accentClass: 'bg-green-100 text-green-600',
    },
    {
      title: 'Preferences Enabled',
      value: `${stats.preferences?.alertsEnabled ?? 0}/${stats.preferences?.digestEnabled ?? 0}/${stats.preferences?.bothEnabled ?? 0}`,
      subtitle: 'Alerts / Digest / Both',
      icon: Clock,
      accentClass: 'bg-purple-100 text-purple-600',
    },
    {
      title: 'Average Open Rate',
      value: `${stats.performance?.avgOpenRate ?? 0}%`,
      subtitle: 'Last 30 days',
      icon: TrendingUp,
      accentClass: 'bg-orange-100 text-orange-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map(({ title, value, subtitle, icon: Icon, accentClass }, idx) => (
        <div key={idx} className="tc-card p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${accentClass}`}>
                <Icon className="h-5 w-5" />
              </div>
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium tc-text-secondary truncate">{title}</dt>
                <dd className="text-lg font-medium tc-text-primary">{value}</dd>
                <dd className="text-xs tc-text-tertiary">{subtitle}</dd>
              </dl>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
